import React from 'react';
import { Drawer as D } from '@mui/material';

const Drawer = ({
  anchor = 'left',
  variant = 'permanent',
  children,
  isOpen = true,
}) => {
  return (
    <D
      anchor={anchor}
      variant={variant}
      open={isOpen}
      sx={{ boxShadow: 2 }}
    >
      {children}
    </D>
  );
};

export default Drawer;
